'use es6';

import { Component } from 'react';
import { memoize, bind, flatten } from 'underscore';
import { connect } from 'react-redux';
import { getHasAllResponsiveToolbarMeasurements, getShouldUseCustomSections } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getHasAnyFlexColumns, getHasAnyLayoutSections, getHasRichTextModuleThatSupportsModuleInsertion, getHasAnyGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { layoutSectionToolbarMeasured as layoutSectionToolbarMeasuredAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import MeasureOnceOffscreen from 'layout-dnd-components/MeasureOnceOffscreen';
import WaitUntilFontsAndIconsAreLoaded from 'layout-dnd-components/WaitUntilFontsAndIconsAreLoaded';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { RESPONSIVE_SIZES } from 'layout-dnd-components/DndToolbar/constants';
import ResponsiveInsertNewSectionHandle from 'InpageEditorUI/components/responsiveToolbar/ResponsiveInsertNewSectionHandle';
import { MockResponsiveDesktopModuleToolbarToMeasure, MockResponsiveMobileModuleToolbarToMeasure, MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure, MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure, MockResponsiveMobileModuleWithoutAccessToolbarToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveToolbarToMeasure';
import { MockResponsiveDesktopEmptyContainerToolbarToMeasure, MockResponsiveMobileEmptyContainerToolbarToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveEmptyContainerToolbarToMeasure';
import { MockResponsiveDesktopSectionToolbarToMeasure, MockResponsiveMobileSectionToolbarToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveSectionToolbarToMeasure';
import { MockResponsiveDesktopColumnToolbarToMeasure, MockResponsiveMobileColumnToolbarToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveColumnToolbarToMeasure';
import { MockResponsiveDesktopRowToolbarToMeasure, MockResponsiveMobileRowToolbarToMeasure, MockResponsiveMobileRowToolbarWithHideIconToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveRowToolbarToMeasure';
import { MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure, MockResponsiveMobileModuleToolbarInFlexColumnToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveToolbarInFlexColumnToMeasure';
import { MockResponsiveDesktopModuleToolbarOutsideContainerToMeasure, MockResponsiveMobileModuleToolbarOutsideContainerToMeasure } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveToolbarOutsideContainerToMeasure';
import { MockResponsiveDesktopHeaderToolbar, MockResponsiveMobileHeaderToolbar } from 'InpageEditorUI/components/responsiveToolbar/MockResponsiveHeaderToolbar';
import { TOOLBAR_TYPES } from 'InpageEditorUI/lib/toolbarUtils';
import debugFontsAndIconsLoaded from 'InpageEditorUI/lib/debugFontsAndIconsLoaded';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { MockDesktopResponsiveToolbarInRichText, MockMobileResponsiveToolbarInRichText } from '../components/responsiveToolbar/ResponsiveToolBarInRichText';
import BaseGridTableToolbar from '../components/gridsToolbar/BaseGridTableToolbar';
import BaseHorizontalStackToolbar from '../components/gridsToolbar/BaseHorizontalStackToolbar';
import BaseVerticalStackToolbar from '../components/gridsToolbar/BaseVerticalStackToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  hasAnyPostBodyModules: getHasRichTextModuleThatSupportsModuleInsertion(state),
  hasAnyFlexColumns: getHasAnyFlexColumns(state),
  hasAnyLayoutSections: getHasAnyLayoutSections(state),
  hasAnyGridLayouts: getHasAnyGridLayouts(state),
  hasAllResponsiveToolbarMeasurements: getHasAllResponsiveToolbarMeasurements(state),
  shouldUseCustomSections: getShouldUseCustomSections(state),
  isInDeveloperMode: getIsInDeveloperMode(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  layoutSectionToolbarMeasured: info => dispatch(layoutSectionToolbarMeasuredAction(info))
});
const MODULE_IN_FLEX_COLUMN_TYPE_AND_COMPONENT_TUPLE_DESKTOP = {
  toolbarType: TOOLBAR_TYPES.DESKTOP.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopModuleToolbarInFlexColumnToMeasure
};
const MODULE_IN_FLEX_COLUMN_TYPE_AND_COMPONENT_TUPLE_MOBILE = {
  toolbarType: TOOLBAR_TYPES.MOBILE.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileModuleToolbarInFlexColumnToMeasure
};
const MODULE_OUTSIDE_CONTAINER_TYPE_AND_COMPONENT_TUPLE_DESKTOP = {
  toolbarType: TOOLBAR_TYPES.DESKTOP.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopModuleToolbarOutsideContainerToMeasure
};
const MODULE_OUTSIDE_CONTAINER_TYPE_AND_COMPONENT_TUPLE_MOBILE = {
  toolbarType: TOOLBAR_TYPES.MOBILE.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileModuleToolbarOutsideContainerToMeasure
};
const MODULE_IN_RICH_TEXT_TYPE_AND_COMPONENT_TUPLE_DESKTOP = {
  toolbarType: TOOLBAR_TYPES.DESKTOP.MODULE_IN_RICH_TEXT,
  ComponentForType: MockDesktopResponsiveToolbarInRichText
};
const MODULE_IN_RICH_TEXT_TYPE_AND_COMPONENT_TUPLE_MOBILE = {
  toolbarType: TOOLBAR_TYPES.MOBILE.MODULE_IN_RICH_TEXT,
  ComponentForType: MockMobileResponsiveToolbarInRichText
};
const ALL_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TUPLES_DESKTOP = [{
  toolbarType: TOOLBAR_TYPES.DESKTOP.SECTION_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopSectionToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.COLUMN_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopColumnToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.ROW_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopRowToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.MODULE_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopModuleToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.EMPTY_CONTAINER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopEmptyContainerToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.INSERT_NEW_SECTION_HANDLE_TYPE,
  ComponentForType: ResponsiveInsertNewSectionHandle
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.HEADER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopHeaderToolbar
}];
const ALL_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TUPLES_MOBILE = [{
  toolbarType: TOOLBAR_TYPES.MOBILE.SECTION_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileSectionToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.COLUMN_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileColumnToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileRowToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_WITH_HIDE_ICON_TYPE,
  ComponentForType: MockResponsiveMobileRowToolbarWithHideIconToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.MODULE_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileModuleToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.EMPTY_CONTAINER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileEmptyContainerToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.HEADER_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileHeaderToolbar
}];
const GRID_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TYPES = [{
  toolbarType: TOOLBAR_TYPES.DESKTOP.VERTICAL_STACK_TOOLBAR,
  ComponentForType: BaseVerticalStackToolbar
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.HORIZONTAL_STACK_TOOLBAR,
  ComponentForType: BaseHorizontalStackToolbar
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.SECTION_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopSectionToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.GRID_TABLE_TOOLBAR,
  ComponentForType: BaseGridTableToolbar
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.MODULE_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveDesktopModuleToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.INSERT_NEW_SECTION_HANDLE_TYPE,
  ComponentForType: ResponsiveInsertNewSectionHandle
}];
const GRID_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TYPES_MOBILE = [{
  toolbarType: TOOLBAR_TYPES.MOBILE.VERTICAL_STACK_TOOLBAR,
  ComponentForType: BaseVerticalStackToolbar
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.HORIZONTAL_STACK_TOOLBAR,
  ComponentForType: BaseHorizontalStackToolbar
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.SECTION_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileSectionToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.GRID_TABLE_TOOLBAR,
  ComponentForType: BaseGridTableToolbar
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.MODULE_TOOLBAR_TYPE,
  ComponentForType: MockResponsiveMobileModuleToolbarToMeasure
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.INSERT_NEW_SECTION_HANDLE_TYPE,
  ComponentForType: ResponsiveInsertNewSectionHandle
}];
const ALL_ADVANCED_MODULE_WITHOUT_ACCESS_TUPLES = [{
  toolbarType: TOOLBAR_TYPES.DESKTOP.ADVANCED_MODULE_WITHOUT_ACCESS,
  ComponentForType: MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure,
  mobile: false
}, {
  toolbarType: TOOLBAR_TYPES.DESKTOP.EDITABLE_MODULE_WITHOUT_ACCESS,
  ComponentForType: MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure,
  mobile: false
}, {
  toolbarType: TOOLBAR_TYPES.MOBILE.ADVANCED_MODULE_WITHOUT_ACCESS,
  ComponentForType: MockResponsiveMobileModuleWithoutAccessToolbarToMeasure,
  mobile: true
}];

/**
 * @param {boolean} props.hasAnyPostBodyModules (required)
 * @param {boolean} props.hasAnyFlexColumns (required)
 * @param {boolean} props.hasAnyLayoutSections (required)
 * @param {Function} props.layoutSectionToolbarMeasured (required)
 * @param {boolean} props.hasAllResponsiveToolbarMeasurements (required)
 * @param {boolean} props.shouldUseCustomSections (optional)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
class ResponsiveToolbarsMeasurementsContainer extends Component {
  constructor(props) {
    super(props);
    this.createCollectMeasurementFor = memoize(bind(this.createCollectMeasurementFor, this));
  }
  componentDidMount() {
    if (window.SELENIUM_IS_RUNNING) {
      console.warn('ResponsiveToolbarsMeasurementsContainer mounted');
      debugFontsAndIconsLoaded();
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.hasAllResponsiveToolbarMeasurements && this.props.hasAllResponsiveToolbarMeasurements) {
      document.body.setAttribute('data-selenium', 'module-toolbars-loaded');
    }
  }
  createCollectMeasurementFor([name, size]) {
    const {
      layoutSectionToolbarMeasured
    } = this.props;
    return ({
      width,
      height
    }) => {
      if (window.SELENIUM_IS_RUNNING) {
        console.warn('Dispatching measurements from ResponsiveToolbarsMeasurementsContainer\n', JSON.stringify({
          name,
          size,
          width,
          height
        }, null, 4));
      }
      layoutSectionToolbarMeasured({
        name,
        size,
        width,
        height
      });
    };
  }
  tuplesForAllDesktopToolbarsToMeasure() {
    const {
      hasAnyFlexColumns,
      hasAnyLayoutSections,
      hasAnyPostBodyModules,
      hasAnyGridLayouts
    } = this.props;
    let result = [MODULE_OUTSIDE_CONTAINER_TYPE_AND_COMPONENT_TUPLE_DESKTOP];
    if (hasAnyFlexColumns) {
      result.push(MODULE_IN_FLEX_COLUMN_TYPE_AND_COMPONENT_TUPLE_DESKTOP);
    }
    if (hasAnyPostBodyModules) {
      result.push(MODULE_IN_RICH_TEXT_TYPE_AND_COMPONENT_TUPLE_DESKTOP);
    }
    if (hasAnyLayoutSections) {
      result = result.concat(ALL_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TUPLES_DESKTOP);
    }
    if (hasAnyGridLayouts) {
      result = result.concat(GRID_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TYPES);
    }
    return result;
  }
  tuplesForAllMobileToolbarsToMeasure() {
    const {
      hasAnyFlexColumns,
      hasAnyLayoutSections,
      hasAnyPostBodyModules,
      hasAnyGridLayouts
    } = this.props;
    let result = [MODULE_OUTSIDE_CONTAINER_TYPE_AND_COMPONENT_TUPLE_MOBILE];
    if (hasAnyFlexColumns) {
      result.push(MODULE_IN_FLEX_COLUMN_TYPE_AND_COMPONENT_TUPLE_MOBILE);
    }
    if (hasAnyPostBodyModules) {
      result.push(MODULE_IN_RICH_TEXT_TYPE_AND_COMPONENT_TUPLE_MOBILE);
    }
    if (hasAnyLayoutSections) {
      result = result.concat(ALL_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TUPLES_MOBILE);
    }
    if (hasAnyGridLayouts) {
      result = result.concat(GRID_DND_AREA_TOOLBAR_TYPE_AND_COMPONENT_TYPES_MOBILE);
    }
    return result;
  }
  renderMeasurementComponentFor({
    size,
    toolbarType,
    ComponentForType,
    isInNonDefaultBreakpointMode,
    isAdvancedModuleWithoutAccess = false,
    shouldUseCustomSections,
    isInDeveloperMode
  }) {
    if (window.SELENIUM_IS_RUNNING) {
      console.warn(`Building measurement components for, ${toolbarType} ${size}`);
    }
    return /*#__PURE__*/_jsx(MeasureOnceOffscreen, {
      onMeasure: this.createCollectMeasurementFor([toolbarType, size]),
      children: /*#__PURE__*/_jsx(ComponentForType, {
        isInNonDefaultBreakpointMode: isInNonDefaultBreakpointMode,
        active: true,
        responsiveSize: size,
        isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
        shouldUseCustomSections: shouldUseCustomSections,
        isInDeveloperMode: isInDeveloperMode
      })
    }, `${toolbarType}-${size}`);
  }
  renderAllAdvancedModulesWithoutAccess(size) {
    const result = ALL_ADVANCED_MODULE_WITHOUT_ACCESS_TUPLES.map(tuple => this.renderMeasurementComponentFor({
      size,
      toolbarType: tuple.toolbarType,
      ComponentForType: tuple.ComponentForType,
      isAdvancedModuleWithoutAccess: true,
      isInNonDefaultBreakpointMode: tuple.mobile
    }));
    return result;
  }
  render() {
    const {
      hasAllResponsiveToolbarMeasurements,
      shouldUseCustomSections,
      isInDeveloperMode
    } = this.props;
    if (hasAllResponsiveToolbarMeasurements) {
      return null;
    }
    const allDesktopMeasurementElements = flatten(RESPONSIVE_SIZES.map(size => this.tuplesForAllDesktopToolbarsToMeasure().map(({
      toolbarType,
      ComponentForType
    }) => this.renderMeasurementComponentFor({
      size,
      toolbarType,
      isInNonDefaultBreakpointMode: false,
      ComponentForType,
      shouldUseCustomSections,
      isInDeveloperMode
    }))));
    const allMobileMeasurementElements = flatten(RESPONSIVE_SIZES.map(size => this.tuplesForAllMobileToolbarsToMeasure().map(({
      toolbarType,
      ComponentForType
    }) => this.renderMeasurementComponentFor({
      size,
      toolbarType,
      isInNonDefaultBreakpointMode: true,
      ComponentForType,
      shouldUseCustomSections,
      isInDeveloperMode
    }))));
    const allAdvancedModulesWithoutAccessMeasurementElements = flatten(RESPONSIVE_SIZES.map(size => this.renderAllAdvancedModulesWithoutAccess(size)));
    return /*#__PURE__*/_jsx(WaitUntilFontsAndIconsAreLoaded, {
      children: /*#__PURE__*/_jsx("div", {
        className: NAMESPACE_CLASS,
        children: allDesktopMeasurementElements.concat(allMobileMeasurementElements).concat(allAdvancedModulesWithoutAccessMeasurementElements)
      })
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveToolbarsMeasurementsContainer);